// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e9Nk","colMin":"styles_colMin__ZwR7M"};